<template>
  <div class="app__container">
    <div class="page404">
      <p>{{ $t("common.not_found") }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "NotFoundPage",
};
</script>
